exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".import-file-view-section .hr-line {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/import_file_view/import_file_view.scss
// module id = 994
// module chunks = 1